import PluginConfiguration from "./PluginConfiguration";
import PluginItemView from "./PluginItemView";

export default {
    pluginTypeId: 'comments',
    pluginTypeName: 'Comments',
    PluginConfiguration: PluginConfiguration,
    PluginItemView: PluginItemView
}



// WEBPACK FOOTER //
// ./src/components/plugins/commentsPlugin/index.js